import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { getEarliestProjectCreatedDate } from '../store/selectors/filteredProjects';
import { createdMonthChanged } from '../store/slices/projectFiltersSlice';
import { useAppDispatch, useAppSelector } from './hooks';

export function ProjectsDateFilterPicker() {
  const dispatch = useAppDispatch();
  const createdMonth = useAppSelector((state) => state.projectFilters.createdMonth);
  const earliestCreatedDate = useAppSelector(getEarliestProjectCreatedDate);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={['month', 'year']}
        format="MM/YYYY"
        label="Created"
        formatDensity="dense"
        minDate={earliestCreatedDate ? dayjs(earliestCreatedDate).startOf('month') : undefined}
        maxDate={dayjs().endOf('month')}
        value={createdMonth ? dayjs(`${createdMonth}-01`) : null}
        onChange={(date) => dispatch(createdMonthChanged(date?.isValid() ? date.format('YYYY-MM') : null))}
        slotProps={{
          field: { clearable: true },
          textField: { size: 'small' },
        }}
        sx={{ width: 200 }}
      />
    </LocalizationProvider>
  );
}
